import { cn } from '@/lib/utils';
import { ChatParticipant } from '@my-ipractice/types';
import { useTranslation } from 'react-i18next';

type Props = {
  participant: ChatParticipant;
  large?: boolean;
};

export const ChatParticipantNameAndRole = ({ participant, large }: Props) => {
  const { t } = useTranslation();

  const getParsedRole = (role: string) => {
    if (role === 'client') return t('chat_page.chatParticipantsRoleYou');
    if (role === 'online_psychologist')
      return t('chat_page.chatParticipantsRoleOnlinePsychologist');
    if (role === 'consultation_room_psychologist')
      return t('chat_page.chatParticipantsRoleConsultationRoomPsychologist');

    return t('chat_page.chatParticipantsRolePsychologist');
  };

  return (
    <div>
      <p className={cn('font-medium', large && 'text-lg')}>{participant.name}</p>
      <p className={cn('opacity-75 text-xs', large && 'text-sm')}>
        {participant.name !== 'iPractice chat service'
          ? `${getParsedRole(participant.role)}`
          : 'Bot'}
      </p>
    </div>
  );
};
